// SHOP BY COLOR DESKTOP GRID VIEW
class ShopByColor extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    var forEach = function (array, callback, scope) {
      for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]);
      }
    }
    
    var sliders = this.querySelectorAll('.shop-by-color-desktop__slider');
    // chunk function to make groups for every slider's children
    var makeGrid = function (array, size) {
      let arr = [];
      for (let i = 0; i < array.length; i += size) {
        let newSlicedArray = Array.prototype.slice.call(array, i, i + size);
        arr.push(newSlicedArray);
      }
      return arr;
    }
    
    // applying forEach function to the sliders
    forEach(sliders, function (index, value) {
      // selecting children
      const childrens = value.querySelectorAll(".shop-by-color-desktop__slider .list-collections__item");
    
      // getting size size from the parent data attribute
      const gridSize = value.getAttribute("data-grid-size");
    
      // making final arrays for the children with chunk size
      const final = makeGrid(childrens, parseInt(gridSize));
    
      // wrapping the grid items with div.wrap
      final.map(towrap => towrap.reduce((acc, el) => (acc.appendChild(el), acc), document.createElement('div')))
        .forEach(el => {
          el.className = "wrap"; // Add a 'wrap' class to each chunk
          value.appendChild(el); // Append the chunk to the slider container
        });
      
      value.classList.add('slider-main-wrapper');
    
      // initialize Flickity    
      var flkty = new Flickity(value, {
        cellAlign: 'left',
        contain: true,
        groupCells: 1,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        autoPlay: false,
        dragThreshold: 10,
        freeScroll: false,
        cellSelector: '.wrap',
        gutter: 20
      });
    });
  }

}
customElements.define('shop-by-color', ShopByColor);